import { Component, OnInit, Input } from '@angular/core';
import { Contact } from '../../contact.model';
import { ContactService } from '../../contact.service';
import { Observable } from 'rxjs';
import { ContactMessage } from '../../contact-message.model';
import { AvailableServicesService } from 'src/app/service-provider/available-services-layout/available-services.service';
import { Service } from 'src/app/service-provider/service.model';
import { AngularFireStorage } from '@angular/fire/storage';
import { switchMap, map } from 'rxjs/operators';
import * as moment from 'moment';

@Component({
  selector: 'app-conversation-preview',
  templateUrl: './conversation-preview.component.html',
  styleUrls: ['./conversation-preview.component.scss']
})
export class ConversationPreviewComponent implements OnInit {
  @Input() contact: Contact;

  lastMessage$: Observable<ContactMessage>;
  lastMessageTimeFormatted$: Observable<string>;
  unreadMessages$: Observable<number>;
  serviceProvider$: Observable<Service>;
  serviceProfileURL$: Observable<string>;

  constructor(
    private contactService: ContactService,
    private availableServices: AvailableServicesService,
    private firestore: AngularFireStorage
  ) {}

  ngOnInit(): void {
    this.lastMessage$ = this.contactService.getLatestContactMessage(
      this.contact.serviceKey,
      this.contact.clientUserKey
    );

    this.lastMessageTimeFormatted$ = this.lastMessage$.pipe(
      map(lastMessage =>
        moment(lastMessage.timeStamp.toDate()).format('HH:mm DD/MM/YY')
      )
    );

    this.serviceProvider$ = this.availableServices.getServiceByKey(
      this.contact.serviceKey
    );
    this.serviceProfileURL$ = this.serviceProvider$.pipe(
      switchMap(serviceProvider => {
        if (!!serviceProvider.imageId) {
          return this.firestore
            .ref(`service-provider-profiles/${serviceProvider.imageId}`)
            .getDownloadURL();
        } else {
          return this.firestore.ref(`unknown-profile.jpg`).getDownloadURL();
        }
      })
    );
  }
}
